import { DefaultTheme } from 'styled-components'

export const darkTheme: DefaultTheme = {
  // bgColor: "#2f3640",
  textColor: '#000'
  // accentColor: "#fbc531",
  // cardBgColor: "#171b20",
  // cardBgHovColor: "#222",
}

export const lightTheme: DefaultTheme = {
  // bgColor: "#dcdde1",
  textColor: 'red'
  // accentColor: "#fbc531",
  // cardBgColor: "#fefefe",
  // cardBgHovColor: "#eee",
}
